/**
 * RichEditor 的**懒加载包装**（对外 props 与 RichEditor 完全一致）
 *
 * 为什么需要它：
 *   wangEditor-next + 其 Slate 内核体积较大。如果不做代码分割，
 *   它会被打进**入口 chunk**，于是连只用手机看科普文章的用户
 *   也要为首屏多下载约 200KB（gzip）的编辑器代码。
 *   而富文本编辑器只在后台「内容编辑 / 礼品详细介绍」两处用到，
 *   所以这里用 React.lazy 按需加载 —— 只有真正打开后台编辑器的
 *   管理员才会拉取编辑器代码，用户端首屏不受影响。
 *
 * 用法：把 `import RichEditor from '../../components/RichEditor'`
 *       换成 `import RichEditor from '../../components/RichEditorLazy'` 即可，
 *       调用处无需再自己包 <Suspense>。
 */
import { lazy, Suspense } from 'react'
import type { RichEditorProps } from './RichEditor'

const RichEditor = lazy(() => import('./RichEditor'))

/** 加载占位：高度与编辑器接近，避免布局跳动 */
const EditorSkeleton = () => (
  <div className="rich-editor rounded-lg border border-gray-200 bg-white">
    <div className="flex items-center gap-2 border-b border-gray-100 px-4 py-3 text-sm text-gray-400">
      <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-gray-300 border-t-[#02b3b7]" />
      编辑器加载中…
    </div>
    <div className="h-[320px] animate-pulse rounded-b-lg bg-gray-50" />
  </div>
)

const RichEditorLazy = (props: RichEditorProps) => (
  <Suspense fallback={<EditorSkeleton />}>
    <RichEditor {...props} />
  </Suspense>
)

export default RichEditorLazy
